// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ur = {
  game: `کھیل`,
  games: `کھیلیں`,
  sport: `کھیل`,
  center: `مرکز`,
  mines: `مائنز`,
  crash: `کریش`,
  lucky_colour: `لکی کلر`,
  dice: `ڈائس`,
  limbo: `لیمبو`,
  lucky_gift: `خوش قسمت تحفہ`,
  all_games: `تمام گیمز`,
  game_history: `کھیل کی تاریخ`,
  coupon_code: `کپون کوڈ`,
  telegram: `ٹیلیگرام`,
  customer_service: `صارف خدمت`,
  player: `کھلاڑی`,
  winner: `فاتح`,
  all_bets: `تمام شرطیں`,
  my_bets: `میری شرطیں`,
  name: `نام`,
  time: `وقت`,
  bet_amount: `شرط کی رقم`,
  prediction: `پیشن گوئی`,
  payout: `ادائیگی`,
  login: `لاگ ان`,
  register: `رجسٹر کریں۔`,
  username_placeholder: `صارف نام`,
  please_input_your_x: `براہ کرم اپنا {{x}} درج کریں`,
  verification_code: `تصدیقی کوڈ`,
  press_get_code: `ایس ایم ایس کے ذریعے تصدیقی کوڈ حاصل کرنے کے لیے GET CODE بٹن دبائیں۔`,
  otp_sent: `تصدیقی کوڈ بھیجا گیا! جاری رکھنے کے لیے ذیل میں تصدیقی کوڈ درج کریں۔`,
  your_otp_expire: `آپ کے OTP کی میعاد ختم ہو جائے گی۔`,
  get_code: `کوڈ حاصل کریں۔`,
  didnt_receive: `کیا پیغام موصول نہیں ہوا؟`,
  send_again: `دوبارہ بھیجیں۔`,
  captcha: `کیپچا`,
  forgot_password: `پاس ورڈ بھول گئے؟`,
  minor_note: `اس سائٹ کو دیکھنے کے لیے، یقینی بنائیں کہ آپ کی عمر 18 سال سے زیادہ ہے اور آپ متفق ہیں۔`,
  terms_of_service: `سروس کی شرائط`,
  by_signing_in: 'سائن ان یا سائن اپ کرکے، آپ ہماری بات سے اتفاق کرتے ہیں۔',
  dont_have_account: `اکاؤنٹ نہیں ہے؟ `,
  sign_up: `سائن اپ کریں!`,
  username: `صارف نام`,
  email: `ای میل`,
  full_name: `پورا نام`,
  confirm_18: `میں تصدیق کرتا ہوں کہ میری عمر 18 سال ہے اور میں نے پڑھا ہے۔`,
  already_have_account: `پہلے سے ہی اکاؤنٹ ہے؟`,
  share: `شیئر کریں۔`,
  deposit: `جمع`,
  bonus: `بونس`,
  app: `ایپ`,
  load_more: `مزید لوڈ کریں۔`,
  details: `تفصیلات`,
  helps: `مدد کرتا ہے۔`,
  kyc_policy: `کے وائی سی پالیسی`,
  privacy_policy: `رازداری کی پالیسی`,
  responsible_gaming: `ذمہ دار گیمنگ`,
  terms_and_condition: `شرائط و ضوابط`,
  faq: `اکثر پوچھے گئے سوالات`,
  about_us: `ہمارے بارے میں`,
  amount: `رقم`,
  extra: `اضافی`,
  deposit_bonus: `جمع بونس`,
  do_not_participate: `پروموشنز میں حصہ نہ لیں۔`,
  payment_problem: `ادائیگی کا مسئلہ`,
  click_for_help: `مدد کے لیے کلک کریں۔`,
  deposit_notes: `جمع نوٹ`,
  available_balance: `دستیاب بیلنس`,
  withdraw: `واپس لینا`,
  withdrawal_notes: `واپسی کے نوٹس`,
  withdrawal_note1: `موجودہ میں نکالنے کی تعداد`,
  withdrawal_note1_1: `وی آئی پی`,
  withdrawal_note2: `واپسی کی فیس:`,
  min: `کم از کم:`,
  max: `زیادہ سے زیادہ:`,
  opening_times: `کھلنے کے اوقات:`,
  withdrawal_note3: `1. سب سے تیز واپسی کا وقت، 10 منٹ کے اندر`,
  withdrawal_note4: `2. یقینی بنائیں کہ آپ کی واپسی کی معلومات درست ہیں، اگر واپسی کی معلومات غلط ہوں تو اس کی وجہ سے آپ کے فنڈز ضائع ہو سکتے ہیں۔`,
  withdrawal_note5: `3. اگر آپ کو کوئی سوال ہو تو بلا جھجھک ہم سے رابطہ کریں۔`,
  notifications: `اطلاعات`,
  invalid_x: `غلط {{x}}`,
  captcha_not_match: `کیپچا میل نہیں کھاتا`,
  invalid_x_must_be_atleast_y_characters: `غلط {{x}}، کم از کم {{y}} حروف ہونے چاہئیں`,
  x_is_required: `{{x}} ضروری ہے`,
  phone_number: 'فون نمبر',
  phone_num_x_max: `فون نمبر زیادہ سے زیادہ {{x}} ہندسے ہونے چاہئیں`,
  email_sent: `ای میل بھیجی گئی، براہ کرم اپنا ای میل چیک کریں۔`,
  enter_valid_email: `براہ کرم ایک درست ای میل درج کریں۔`,
  confirm: `تصدیق کریں۔`,
  password_atleast_6_characters: `پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے۔`,
  password_reset_success: `پاس ورڈ کامیابی سے ری سیٹ ہو گیا!`,
  new_password: `نیا پاس ورڈ`,
  bank: 'بینک',
  bank_transfer: `بینک ٹرانسفر`,
  bank_name: `بینک کا نام`,
  bank_branch: `بینک بی ایس بی`,
  pay_id: `پی آئی ڈی`,
  account_name: `اکاؤنٹ کا نام`,
  account_number: `اکاؤنٹ نمبر`,
  drop_or_select: `فائل کو ڈراپ یا سلیکٹ کریں۔`,
  drop_files_here: `فائلیں یہاں چھوڑیں`,
  transfer_to: `پر منتقل کریں۔`,
  upload_receipt: `رسید اپ لوڈ کریں`,
  select_bonus: `بونس منتخب کریں۔`,
  no_promotion: `کوئی پروموشن نہیں۔`,
  please_upload_receipt: `براہ کرم رسید اپ لوڈ کریں۔`,
  bank_account: `بینک اکاؤنٹ`,
  add_account: `اکاؤنٹ شامل کریں۔`,
  account_holder_name: `اکاؤنٹ ہولڈر کا نام`,
  name_of_the_account_holder: `اکاؤنٹ ہولڈر کا نام`,
  fill_in_bank_account: `بینک اکاؤنٹ بھریں۔`,
  withdraw_information: `معلومات واپس لیں۔`,
  note: `نوٹ`,
  amount_withdrawn: `نکالی گئی رقم`,
  amount_no_exceed_balance: `نکالنے کی رقم دستیاب بیلنس سے زیادہ نہیں ہونی چاہیے۔`,
  minimum_withdraw_amount_is_x: `کم از کم رقم نکالنے کی رقم {{x}} ہے`,
  transaction_history: `لین دین کی تاریخ`,
  date_from: `سے تاریخ`,
  date_to: `تاریخ تک`,
  account_name_must_be_4: `اکاؤنٹ کا نام 4 حروف سے زیادہ لمبا ہونا چاہیے۔`,
  account_number_must_be_x: `اکاؤنٹ نمبر کی لمبائی 10 سے 14 حروف کے درمیان ہونی چاہیے۔`,
  minimum_length_is_x: `کم از کم لمبائی {{x}} ہے`,
  maximum_length_is_x: `زیادہ سے زیادہ لمبائی {{x}} ہے`,
  payment_method: `ادائیگی کا طریقہ`,
  mode: `موڈ`,
  no_bank_account: `آپ کے پاس نکالنے کے لیے کوئی اکاؤنٹ نہیں ہے، ابھی شامل کریں۔`,
  please_select_bank: `براہ کرم ایک بینک اکاؤنٹ منتخب کریں۔`,

  bet_history: `شرط کی تاریخ`,
  game_provider: `گیم فراہم کنندہ`,
  bet_count: `شرط شمار`,
  win_loss: `جیت/ہار`,
  rebate: `چھوٹ`,
  turnover: `ٹرن اوور`,
  game_category: `کھیل زمرہ`,

  you_have_x_unread_messages: `آپ کے پاس {{x}} بغیر پڑھے ہوئے پیغامات ہیں۔`,
  deposit_amount_between_x_and_y: `جمع کی رقم {{x}} اور {{y}} کے درمیان ہونی چاہیے`,
  minimum_amount_is_x_y: `کم از کم رقم {{x}} {{y}} ہے`,

  // all
  all: `تمام`,
  title: `عنوان`,
  date: `تاریخ`,
  type: `قسم`,
  status: `حیثیت`,
  remark: `تبصرہ`,
  category: `زمرہ`,
  please_select_x: `براہ کرم {{x}} کو منتخب کریں`,
  save: `محفوظ کریں`,

  change_password: `پاس ورڈ تبدیل کریں۔`,
  current_password: `موجودہ پاس ورڈ`,
  confirm_password: `پاس ورڈ کی تصدیق کریں۔`,
  submit: `جمع کروائیں۔`,
  password_changed: `پاس ورڈ تبدیل کر دیا گیا۔`,
  x_must_be_y_characters: `{{x}} کم از کم {{y}} حروف کا ہونا چاہیے۔`,
  reset_password: `پاس ورڈ ری سیٹ کریں۔`,
  casino: `کیسینو`,
  slots: `سلاٹس`,
  live_casino: `لائیو کیسینو`,
  fishing: `ماہی گیری`,
  sports: `کھیل`,
  cards: `کارڈز`,
  clear: `صاف`,
  search: `تلاش کریں۔`,
  new: `نیا`,
  logout: `لاگ آؤٹ`,
  choose_date: `تاریخ کا انتخاب کریں۔`,
  select_both_date: `تاریخ سے اور تک دونوں کو منتخب کریں۔`,
  from: `سے`,
  to: `کو`,
  apply: `لگائیں`,
  promotions: `پروموشنز`,
  learn_more: `مزید جانیں۔`,
  password_doesnt_match: `پاس ورڈ مماثل نہیں ہے۔`,
  cancel: `منسوخ کریں۔`,
  confirm_to_pay: `ادائیگی کی تصدیق کریں۔`,
  deposit_amount: `جمع رقم`,
  loading_please_wait: `لوڈ ہو رہا ہے، براہ کرم انتظار کریں۔`,
  account: `اکاؤنٹ`,
  profile: `پروفائل`,
  bank_list: `بینک کی فہرست`,
  in_maintenance: `دیکھ بھال میں`,
  birthday: `سالگرہ`,
  birthday_bonus: `بونس کے لیے اپنی سالگرہ درج کریں! 🎉🎁`,
  referral_code: `ریفرل کوڈ`,
  referral: `حوالہ`,
  my_referral: `میرا حوالہ`,
  my_claim: `میرا دعویٰ`,
  claim_profit: `منافع کا دعوی کریں۔`,
  available_profit: `دستیاب منافع`,
  claimed_profit: `دعوی کردہ منافع`,
  all_time_profit: `تمام وقتی منافع`,
  referral_note_on_x: `جب بھی آپ کے دوست {{x}} پر کھیلیں، آپ منافع حاصل کریں`,
  tier: `ٹائر`,
  commission: `کمیشن`,
  referred_member: `ریفرڈ ممبر`,
  profit_earned: `منافع کمایا`,
  account_information: `اکاؤنٹ کی معلومات`,
  invite_friends: `دوستوں کو مدعو کریں۔`,
  how_it_work: `یہ کیسے کام کرتا ہے؟`,
  invite_note: `اپنے ریفرل کوڈ کے ذریعے جب آپ کا دوست سائن اپ کرے تو خصوصی ریفرل بونس حاصل کریں!`,
  share_via: `کے ذریعے شیئر کریں۔`,
  referral_link: `ریفرل لنک`,
  total_profit: `کل منافع`,
  copied: `کاپی`,
  nothing_to_claim: `دعویٰ کرنے کے لیے کچھ نہیں۔`,
  claim_history: `دعوی کی تاریخ`,
  downline: `ڈاؤن لائن`,
  last_x_digit_bank_ref_number: `بینک ریف نمبر کا آخری {{x}} ہندسہ`,
  bank_ref_number_validation_x: `بینک ریف نمبر درکار ہے اور اس کی لمبائی {{x}} ہونی چاہیے۔`,
  sort: 'چھانٹنا',
  login_directly: `کے ساتھ براہ راست لاگ ان کریں۔`,
  our_game_provides: `ہمارے گیم فراہم کرنے والے`,
  refer_and_reward: `حوالہ اور انعام`,
  linked_successfully_x: `{{x}} کے ساتھ کامیابی سے لنک ہو گیا! براہ کرم پہلی بار اپنا اکاؤنٹ رجسٹر کریں۔`,
  more_x_of_y: `مزید {{x}}/{{y}}`,
  default: `طے شدہ`,
  promotion: `پروموشن`,
  daily_mission: 'ڈیلی مشن',
  agent: 'ایجنٹ',
  contact_us: 'ہم سے رابطہ کریں۔',
  download: 'ڈاؤن لوڈ کریں۔',
  cash_claim: 'کیش کلیم',
  demo: 'ڈیمو',
  favorites: 'پسندیدہ',
  popular: 'مقبول',
  claim_bonus: `بونس کا دعوی کریں۔`,
  insufficient_balance: `ناکافی بیلنس`,
  currently_displaying: 'اس وقت {{z}} میں سے {{x}} {{y}} گیمز دکھائی جا رہی ہیں',
  all_x: 'تمام {{x}}',
  no_results: 'کوئی نتیجہ نہیں ملا',
  search_games: 'گیمز تلاش کریں۔',
  please_scan_using_your: `براہ کرم اپنا استعمال کرکے اسکین کریں۔`,
  vip_level: `وی آئی پی لیول`,
  bonus_direct: `براہ راست بونس`,
  rebate_level: `چھوٹ کی سطح`,
  vip_header: `Aliwin789 پر لگائی گئی تمام شرطیں — جیسے کہ سلاٹ مشینز، بورڈ اور کارڈ گیمز، فشنگ، ویڈیوز، اسپورٹس، اور لاٹری گیمز — مستقل طور پر جمع کی جائیں گی۔ درست شرطیں = مستقل آمدنی اور دولت کی کنجی!`,
  vip_example: `
  مثال 1: وہ اراکین جو جمع شدہ ڈپازٹس میں 1 ملین تک پہنچ جاتے ہیں، VIP لیول 2 تک پہنچ جاتے ہیں، R$210 کا بونس حاصل کرتے ہیں، اور 3.50% کی چھوٹ، جب وہ جمع شدہ ڈپازٹ میں 6 ملین تک پہنچ جاتے ہیں، تو وہ VIP لیول 3 تک پہنچ جاتے ہیں اور R$800 کا بونس وصول کرتے ہیں، %4 ریبیٹ کے ساتھ`,
  activity_rules: `سرگرمی کے قواعد:`,
  activity_rules_1: `1. نکاسی کی درخواست کے لیے تمام بونسز پر x3 وِنوور ہونا ضروری ہے۔`,
  activity_rules_2: `2. براہِ مہربانی ریبیٹ بونس مقررہ وقت کے اندر حاصل کریں، اگر آپ دیر کر گئے تو اسے ترک کرنا سمجھا جائے گا۔;`,
  activity_rules_3: `3. ممبرز کی سرگرمیوں میں شرکت خودکار طور پر سسٹم کے ذریعے شمار کی جاتی ہے، اگر کوئی اعتراض ہو تو Aliwin789 کی تحقیق کے نتائج کو ترجیح دی جائے گی۔;`,
  activity_rules_4: `4. اگر آپ اپنا ممبر اکاؤنٹ یا پاس ورڈ بھول جائیں، تو براہِ کرم اپنا اکاؤنٹ دوبارہ حاصل کرنے کے لیے '24 گھنٹے آن لائن کسٹمر سروس' سے رابطہ کریں۔;`,
  activity_rules_5: `5. Aliwin789 کسی بھی وقت اس پروموشن کو تبدیل، روک یا منسوخ کرنے کا حق محفوظ رکھتا ہے۔.`,
  activity_rules_6: `6. فری گیم محفوظ نہ کریں، فری گیم خریدیں`,
  activity_rules_7: `7. کسی بھی بونس کے ساتھ جمع نہیں کیا جا سکتا`,
  activity_rules_8: '8. ہر جمع پر زیادہ سے زیادہ نکالنے کی حد R$100,000 ہے۔',
  agent_p1: 'اپنا منفرد لنک مختلف ایپس اور سوشل میڈیا پر شیئر کریں',
  agent_p2:
    'Facebook، Instagram، Tiktok، Telegram، WhatsApp، YouTube اور دیگر پلیٹ فارمز پر جلدی کریں اور سب کو دعوت دیں۔ جو ممبرز آپ کے خصوصی لنک کے ذریعے رجسٹر ہوں گے وہ آپ کے براہِ راست ایجنٹ بن جائیں گے۔ لیکن دھیان رکھیں کہ آپ کے دعوت دیے گئے نئے ممبرز حقیقی اور مستند ہونے چاہئیں۔.',
  agent_step1:
    'دوست کو دعوت دیں، جب وہ پہلی بار کامیابی سے ڈپازٹ کرے گا، تو آپ R$5 کا بونس جیت سکتے ہیں۔ مثال کے طور پر، اگر آپ 10 لوگوں کو پہلی بار ڈپازٹ کے لیے مدعو کرتے ہیں، تو آپ R$50 کما سکتے ہیں۔ جتنے زیادہ لوگوں کو آپ مدعو کریں گے، اتنے ہی زیادہ بونسز حاصل کریں گے۔ آپ اپنی ہسٹری اور رجسٹریشن پروموشن پیج پر دیکھ سکتے ہیں، جہاں آپ کو بونسز اور اعلیٰ کمیشنز کی تفصیلات ملیں گی۔.',
  agent_step2:
    'اگر آپ کے مہمان R$1 یا اس سے زیادہ کی شرط لگاتے ہیں، تو آپ فوراً اعلیٰ کمیشن سے فائدہ اٹھا سکتے ہیں! آپ زندگی بھر کے لیے 5% تک کمیشن کما سکتے ہیں، اور یہ دعوت ہمیشہ کے لیے ہوگی! سسٹم پچھلے دن کا کمیشن اگلے دن صبح 7 بجے کلیئر کرے گا۔.',
  agent_step2_1: 'حاصل کرنے کا طریقہ: لاگ ان کریں - دعوتی پروموشن پر جائیں - کمیشن حاصل کریں',
  agent_table1: 'سلاٹ، فشنگ اور بلاک چین کے لیے بیٹنگ کمیشن کی شرحیں درج ذیل ہیں:',
  agent_table1_1: '"کسٹمر نے 20 کا ٹاپ اپ کیا اور 200 کی بیٹنگ کی۔',
  person: 'شخص',
  agent_table2_title1: 'ممبر بیٹنگ',
  agent_table2_title2: 'سلاٹ گیم صرف',
  agent_table2_example:
    'مثال: آپ کے 100 اراکین ہیں، اور شرط کی کل حقیقی قیمت کا تخمینہ 1 ملین ریئس یومیہ ہے۔ اس دن آپ کو ملنے والا کمیشن یہ ہے: 1,000,000 x 1.20% 12,000 reais۔ 100,000 کی ماہانہ آمدنی حاصل کرنا انتہائی آسان ہے۔',
  reminder: 'یاد دہانی',
  agent_reminder:
    'ایک ممبر اکاؤنٹ جو ایک ہی IP، ایک ہی ڈیوائس، نام، بینک کارڈ اور دیگر معلومات کے ساتھ ہو، صرف ایک بار اس پروموشن میں حصہ لے سکتا ہے۔ جو کوئی بھی ان قواعد کی خلاف ورزی کرے گا، اسے بونس سے محروم کر دیا جائے گا، یا گروپ ضبط کر لیا جائے گا اور اکاؤنٹس مستقل طور پر منجمد کر دیے جائیں گے۔',
  agent_step3_1:
    'ممبرز کی سرگرمیوں میں شرکت خودکار طور پر سسٹم کے ذریعے شمار کی جاتی ہے، اگر کوئی اعتراض ہو تو Aliwin789 کی کی گئی جانچ پڑتال کے نتائج کو فوقیت دی جائے گی۔',
  agent_step3_2:
    'اگر آپ اپنا ممبر اکاؤنٹ یا پاس ورڈ بھول جائیں، تو براہِ کرم اکاؤنٹ کی معلومات بحال کرنے کے لیے ہماری 24 گھنٹے فعال کسٹمر سروس ٹیم سے رابطہ کریں۔',
  agent_step3_3: 'Aliwin789 کسی بھی وقت پروموشن کو تبدیل، معطل یا منسوخ کرنے کا حق محفوظ رکھتا ہے۔',
  agent_step3_4: 'ایجنٹ کمیشن بونس نقد رقم یا والیٹ کے کریڈٹس کی صورت میں وصول کر سکتا ہے۔',
  agent_step3_5: 'فری گیم محفوظ نہ کریں، فری گیم خریدیں',
  agent_step3_6: 'کسی بھی بونس اور جمع کے ساتھ جمع نہیں کیا جا سکتا۔',
  agent_step3_7: 'صرف سلاٹ گیم کے لیے دستیاب ہے۔',
  promo_concluded: 'پروموشن ختم ہو چکی ہے! کل دوبارہ چیک کریں!',
  can_only_claim: 'صرف {{x}} سے {{y}} برازیل وقت کے درمیان بونس کا دعویٰ کیا جا سکتا ہے۔',
  please_login: 'براہ کرم بونس کا دعوی کرنے کے لیے پہلے لاگ ان کریں!',
  back_to_home: 'واپس گھر پر',
  bonus_claimed: 'بونس کا پہلے ہی دعوی کیا گیا ہے!',
  terms_n_conditions: 'شرائط و ضوابط',
  claim_now: 'ابھی دعوی کریں۔',
  the_activity_x_in: 'سرگرمی {{x}} میں',
  starts: 'شروع ہوتا ہے۔',
  ends: 'ختم ہوتا ہے۔',
  list_of_winners: 'فاتحین کی فہرست',
  days: 'دن',
  hours: 'گھنٹے',
  minutes: `منٹس`,
  seconds: `سیکنڈز`,
  total_amount_received: `موصول ہونے والی کل رقم`,
  deposit_fee: `جمع فیس`,
  get: 'حاصل کریں۔',
  apply_now: `حاصل کرنا`,
  number_exists: 'یہ فون نمبر پہلے سے رجسٹرڈ ہے۔!',
  number_not_exists: 'یہ فون نمبر رجسٹرڈ نہیں ہے۔!',
  payment_draft:
    'اگر آپ تصدیق کرتے ہیں کہ آپ نے ادائیگی کر دی ہے، تو براہِ کرم کچھ دیر انتظار کریں کیونکہ ادائیگی ابھی پراسیس ہو رہی ہو سکتی ہے۔',
  my_downline: 'میرا ڈاؤن لائن',
  downline_name: 'ڈاؤن لائن کا نام',
  date_joined: 'شمولیت کی تاریخ',
  deposit_amount_x_days: 'جمع کی رقم ({{x}} دن)',
  welcome_to_bk: 'Aliwin789 میں خوش آمدید',
  dont_have_an_account: `اکاؤنٹ نہیں ہے؟ `,
  fill_up_here: 'یہاں بھریں',
  currency_and_language: 'کرنسی اور زبان',
  language: 'زبان',
  deposit_channel: `جمع چینل`,
  deposit_details: `جمع کی تفصیلات`,
  bonus_amount: `بونس کی رقم`,
  main_wallet: `مین والیٹ`,
  withdraw_details: `تفصیلات واپس لیں۔`,
  withdraw_amount: `رقم نکالنا`,
  password: 'پاس ورڈ',
  bank_details: `بینک کی تفصیلات`,
  add: `شامل کریں۔`,
  bank_holder_name: `بینک ہولڈر کا نام`,
  bank_account_number: `بینک اکاؤنٹ نمبر`,
  mandatory_field: `یہ ایک لازمی فیلڈ ہے۔`,
  home: `گھر`,
  password_not_match: 'پاس ورڈ مماثل نہیں ہے۔',
  payment_methods: 'ادائیگی کے طریقے',
  customer_support: 'کسٹمر سپورٹ',
  chat_now: 'ابھی چیٹ کریں۔',
  certifications: 'سرٹیفیکیشنز',
  community_website: 'کمیونٹی کی ویب سائٹ',
  gaming_license: 'گیمنگ لائسنس',
  footer_title_1: 'Aliwin789 آن لائن کیسینو کا تعارف',
  footer_paragraph_1:
    'آن لائن گیمز کی دنیا میں خوش آمدید، Aliwin789 میں—بنگلہ دیش کا آپ کا معتبر آن لائن کیسینو! Aliwin789 پر، ہم آپ کو ایک بے مثال گیمنگ تجربہ فراہم کرنے کے لیے پرعزم ہیں جو اعلیٰ سیکیورٹی، دلچسپ کھیل اور خصوصی انعامات کو یکجا کرتا ہے۔ آئیے جانتے ہیں کہ ہمیں دوسروں سے کیا منفرد بناتا ہے اور کیوں ہم آپ کے آن لائن تفریح کے لیے بہترین منزل ہیں۔.',
  footer_title_2: 'سلامتی اور اعتماد',
  footer_paragraph_2:
    'Aliwin789 میں، آپ کی حفاظت ہماری اولین ترجیح ہے۔ ہم جدید ترین انکرپشن ٹیکنالوجی استعمال کرتے ہیں تاکہ آپ کی ذاتی اور مالی معلومات کو محفوظ رکھا جا سکے، تاکہ آپ پر سکون دل کے ساتھ اپنے گیمنگ کے تجربے کا لطف اٹھا سکیں۔ ہمارا پلیٹ فارم مکمل طور پر لائسنس یافتہ اور ضابطہ بند ہے، اور ہر کھیل میں انصاف اور شفافیت کو یقینی بنانے کے لیے سخت معیارات کی پابندی کرتا ہے۔',
  footer_title_3: 'دلچسپ کھیلوں کا انتخاب',
  footer_paragraph_3:
    'تیار ہو جائیں ایک دلچسپ سفر کے لیے ہمارے وسیع کھیلوں کے مجموعے کے ذریعے! کلاسک کیسینو پسندیدہ جیسے سلاٹس، رولیٹی، اور بلیک جیک سے لے کر جدید لائیو ڈیلر تجربات تک، ہم ہر قسم کے کھلاڑی کے لیے کچھ نہ کچھ پیش کرتے ہیں۔ ہمارے کھیل صنعت کے معروف سافٹ ویئر فراہم کنندگان کی طرف سے تیار کیے گئے ہیں، جو شاندار گرافکس، ہموار گیم پلے، اور دلچسپ بونس فیچرز فراہم کرتے ہیں۔',
  footer_paragraph_4:
    'Aliwin789 کے ایک معزز ممبر کے طور پر، آپ کو بے شمار خصوصی بونس اور پروموشنز ملیں گے۔ خوش آمدیدی بونس جو آپ کی ابتدائی جمع کو بڑھاتے ہیں، جاری پروموشنز اور وفاداری کے انعامات تک، ہم اپنے کھلاڑیوں کو سخاوت سے انعام دینے پر یقین رکھتے ہیں۔ ہماری پروموشنز صفحے پر تازہ ترین پیشکشوں پر نظر رکھیں اور اضافی انعامات کے ساتھ اپنے گیمنگ کے تجربے کو زیادہ سے زیادہ بنائیں۔.',
  footer_title_5: 'صارف دوست انٹرفیس',
  footer_paragraph_5:
    'ہمارے پلیٹ فارم پر نیویگیٹ کرنا بہت آسان ہے، کیونکہ ہمارا صارف دوست انٹرفیس آپ کی سہولت کو مدنظر رکھ کر ڈیزائن کیا گیا ہے۔ چاہے آپ ہمارا کیسینو ڈیسک ٹاپ، موبائل، یا ٹیبلٹ ڈیوائسز پر استعمال کر رہے ہوں، آپ کو بغیر کسی رکاوٹ کے کھیلنے اور آسان نیویگیشن کا لطف ملے گا۔ ہمارا آسان انٹرفیس یقینی بناتا ہے کہ آپ اپنی توجہ سب سے اہم چیز پر مرکوز رکھ سکیں — یعنی تفریح اور بڑے انعامات جیتنا۔!',
  footer_title_6: '24 گھنٹے، ہفتے میں 7 دن کسٹمر سپورٹ',
  footer_paragraph_6:
    'مدد چاہیے؟ ہماری وقف کردہ کسٹمر سپورٹ ٹیم 24 گھنٹے، ہفتے میں 7 دن آپ کے سوالات یا مسائل حل کرنے کے لیے دستیاب ہے۔ چاہے آپ کو اکاؤنٹ رجسٹریشن، ادائیگی کے طریقوں، یا کھیل کے قواعد کے بارے میں سوالات ہوں، ہمارے دوستانہ سپورٹ ایجنٹس مدد کے لیے تیار ہیں۔ آپ ہمیں لائیو چیٹ، ای میل، یا فون کے ذریعے رابطہ کر سکتے ہیں، اور ہم یقینی بنائیں گے کہ آپ کا گیمنگ تجربہ آسان اور خوشگوار رہے۔.',
  footer_title_7: 'ذمہ دارانہ گیمنگ',
  footer_paragraph_7:
    'ہم ذمہ دارانہ گیمنگ کے طریقے فروغ دینے اور اپنے کھلاڑیوں کی بھلائی کو یقینی بنانے کے لیے پرعزم ہیں۔ ہمارا پلیٹ فارم مختلف اوزار اور وسائل فراہم کرتا ہے جو آپ کو اپنی گیمنگ سرگرمی کو ذمہ داری کے ساتھ منظم کرنے میں مدد دیتے ہیں۔ جمع کی حدیں مقرر کرنے سے لے کر خود کو عارضی طور پر پابند کرنے کے اختیارات تک، ہم آپ کو اپنے گیمنگ کے عادات پر قابو پانے اور ہمارے پلیٹ فارم کا ذمہ داری کے ساتھ لطف اٹھانے کا اختیار دیتے ہیں۔.',
  footer_title_8: 'لائسنس یافتہ آن لائن کیسینو بنگلہ دیش کے ساتھ مکمل تعمیل',
  footer_paragraph_8:
    'آن لائن گیمنگ کے جوش و خروش کو Aliwin789 کے بہترین کیسینو پلیٹ فارم کے ساتھ بنگلہ دیش میں دریافت کریں۔ کلاسک سلاٹس سے لے کر دلکش لائیو ڈیلر تجربات تک، کھیلوں کی وسیع رینج دریافت کریں۔ ابھی شامل ہوں اور خصوصی بونس اور بے مثال تفریح کا لطف اٹھائیں۔ ذمہ داری کے ساتھ کھیلیں۔ عمر 18 سال یا اس سے زائد ہونی چاہیے۔ شرائط و ضوابط لاگو ہیں۔.',
  footer_title_9: 'Aliwin789 بہترین آن لائن کیسینو تجربہ پیش کرتے ہیں۔',
  footer_paragraph_9:
    'بنگلہ دیش میں آپ کے قابل اعتماد آن لائن کیسینو Aliwin789 کے ساتھ آن لائن گیمنگ تفریح ​​کا حتمی تجربہ کریں۔ سیکیورٹی، جوش و خروش اور انعامات پر توجہ مرکوز کرنے کے ساتھ، ہم آپ کے گیمنگ کے تجربے کو نئی بلندیوں تک پہنچانے کے لیے حاضر ہیں۔ آج ہی ہمارے ساتھ شامل ہوں اور دریافت کریں کہ ہم بنگلہ دیش کے سمجھدار کھلاڑیوں کے لیے ترجیحی انتخاب کیوں ہیں۔ کھیل شروع ہونے دو!',
  footer_copyright: 'کاپی رائٹ © 2024 Aliwin789. جملہ حقوق محفوظ ہیں۔',
  currency: 'کرنسی',
  fill_up_password_here: 'براہ کرم یہاں پاس ورڈ درج کریں۔',
  betting_records: 'شرط بازی کے ریکارڈز',
  turn_over: 'ٹرن اوور',
  transfer_records: 'ٹرانسفر ریکارڈز',
  transaction_records: 'لین دین کے ریکارڈز',
  funds: 'فنڈز',
  history: 'تاریخ',
  claim_voucher: 'واؤچر کا دعوی کریں۔',
  check_in_lucky: 'چیک ان / لکی وہیل',
  personal_info: 'ذاتی معلومات',
  inbox_messages: 'ان باکس پیغامات',
  referral_bonus: 'ریفرل بونس',
  support: '24/7 سپورٹ',
  whatsapp: 'واٹس ایپ',
  facebook: 'فیس بک',
  downloads: 'ڈاؤن لوڈز',
  download_android: 'اینڈرائیڈ ڈاؤن لوڈ کریں۔',
  overview: 'جائزہ',
  referral_program: 'ریفرل پروگرام',
  summary: 'خلاصہ',
  referral_report: 'ریفرل رپورٹ',
  redeem_history: 'تاریخ کو چھڑانا',
  commission_to_redeem: 'چھڑانے کے لیے کمیشن',
  today_commission: 'آج کمیشن',
  this_month_commission: 'اس ماہ کمیشن',
  referral_tier: 'ریفرل ٹائر',
  total: 'کل',
  share_now: 'ابھی شیئر کریں۔',
  complete: 'مکمل',
  back: 'پیچھے',
  c_bet_amount: 'شرط کی رقم',
  c_rebate: 'چھوٹ',
  c_turnover: 'ٹرن اوور',
  c_amount: 'رقم',
  c_bonus: 'بونس',
  c_remarks: 'ریمارکس',
  level: 'سطح',
  no_promotions: 'کوئی پروموشنز نہیں۔',
  dont_show_again: 'دوبارہ مت دکھانا',
  next: 'اگلا',
  close: 'بند',
  crash_game: `کریش گیم`,
  maximum_withdraw_amount_is_x: `زیادہ سے زیادہ نکالنے کی رقم {{x}} ہے۔`,
  no_balance: `کوئی بیلنس نہیں۔`,
  no: `نہیں`,
  optional: `اختیاری`,
  network_error: `نیٹ ورک کی خرابی۔`,
  game_providers: `کھیل فراہم کرنے والے`,
  sub_filters: `ذیلی فلٹرز`,
  balance: 'توازن',
  requirement: 'ضرورت',
  deposit_from_bank: 'بینک سے جمع کروائیں۔',
  footer_banner_desc: `ہمارے 24/7 لائیو بیٹنگ پلیٹ فارم پر بے حد تفریح کے لیے مختلف کھیلوں اور ورچوئلز میں بہترین آڈز حاصل کریں۔`,
  official_partner_of: `کا سرکاری شراکت دار`,
  site_description: `Aliwin789.com میں خوش آمدید، جو ایشیا کی بہترین آن لائن بیٹنگ اور گیمنگ سائٹس میں سے ایک ہے۔.`,
  site_description_1: `علی ون 789 مختلف قسم کے کھیلوں کے بازار اور دنیا بھر کے کھیلوں کے مقابلے پیش کرتا ہے، جہاں آپ 15,000 سے زائد لائیو کھیلوں کے ایونٹس پر شرط لگا سکتے ہیں۔
بہت بڑی تعداد میں لائیو ڈیلرز، سلاٹس، آرکیڈ گیمز اور ہمارے تمام پراڈکٹس پر فراخ دلانہ پروموشنز کے ساتھ، ہم آپ کو دنیا کی اعلیٰ معیار کی آن لائن گیمنگ تفریح فراہم کرنے کا وعدہ کرتے ہیں۔.`,
  site_description_2: `علی ون 789 پر آپ کی سیکیورٹی ہماری اولین ترجیح ہے۔ ہم جدید ترین انکرپشن ٹیکنالوجی استعمال کرتے ہیں تاکہ آپ کی ذاتی اور مالی معلومات کو محفوظ رکھا جا سکے، تاکہ آپ بےفکر ہو کر اپنے گیمنگ کے تجربے کا لطف اٹھا سکیں۔
ہماری پلیٹ فارم مکمل طور پر لائسنس یافتہ اور ریگولیٹڈ ہے، اور ہر کھیل میں منصفانہ اور شفافیت کو یقینی بنانے کے لیے سخت معیار پر عمل کرتی ہے۔.`,
  site_description_3: `علی ون 789 کے معزز رکن کے طور پر، آپ کو بے شمار خصوصی بونسز اور پروموشنز دیے جائیں گے۔ خوش آمدیدی بونسز جو آپ کی پہلی جمع شدہ رقم کو بڑھاتے ہیں، ساتھ ہی جاری پروموشنز اور وفاداری انعامات، ہم اپنے کھلاڑیوں کو فیاضی سے نوازنے پر یقین رکھتے ہیں۔
تازہ ترین آفرز کے لیے ہمارے پروموشنز پیج پر نظر رکھیں اور اضافی انعامات کے ساتھ اپنے گیمنگ کے تجربے کو زیادہ سے زیادہ بنائیں۔.`,
  site_description_4: `علی ون 789 کے معزز رکن کے طور پر، آپ کو بے شمار خصوصی بونسز اور پروموشنز دیے جائیں گے۔ خوش آمدیدی بونسز جو آپ کی پہلی جمع شدہ رقم کو بڑھاتے ہیں، ساتھ ہی جاری پروموشنز اور وفاداری انعامات، ہم اپنے کھلاڑیوں کو فیاضی سے نوازنے پر یقین رکھتے ہیں۔
تازہ ترین آفرز کے لیے ہمارے پروموشنز پیج پر نظر رکھیں اور اضافی انعامات کے ساتھ اپنے گیمنگ کے تجربے کو زیادہ سے زیادہ بنائیں۔`,
  site_description_5: `کیا آپ کو مدد کی ضرورت ہے؟ ہماری وقف شدہ کسٹمر سپورٹ ٹیم 24/7 دستیاب ہے تاکہ آپ کے تمام سوالات یا خدشات کا حل فراہم کرے۔ چاہے آپ کو اکاؤنٹ رجسٹریشن، ادائیگی کے طریقے، یا گیم کے قواعد کے بارے میں کوئی سوال ہو، ہمارے دوستانہ سپورٹ ایجنٹس مدد کے لیے ہمیشہ حاضر ہیں۔
ہم سے لائیو چیٹ، ای میل، یا فون کے ذریعے رابطہ کریں، اور ہم یقینی بنائیں گے کہ آپ کا گیمنگ تجربہ آسان اور خوشگوار رہے۔.`,
  site_description_6: `علی ون 789 کے ساتھ آن لائن گیمنگ کی بہترین تفریح کا تجربہ کریں، جو بنگلہ دیش میں آپ کا معتبر آن لائن کیسینو ہے۔
سیکیورٹی، جوش و خروش، اور انعامات پر توجہ کے ساتھ، ہم آپ کے گیمنگ کے تجربے کو نئی بلندیوں تک لے جانے کے لیے یہاں موجود ہیں۔
آج ہی ہمارے ساتھ شامل ہوں اور جانیں کہ کیوں بنگلہ دیش بھر کے سمجھدار کھلاڑی ہمیں اپنی پہلی پسند سمجھتے ہیں۔
کھیل شروع کریں!`,
  payment: `ادائیگی`,
  vip_faq: `وی آئی پی ممبرشپ کے اکثر پوچھے گئے سوالات`,
  vip_faq_1: `علی ون 789 کا وی آئی پی ممبر کیسے بنیں؟`,
  vip_faq_2: `بغیر کسی جھنجھٹ کے، بغیر کسی اضافی قیمت کے!`,
  vip_faq_3: `بس علی ون 789 پر رکن بنیں، جمع کروائیں اور شرط لگانا شروع کریں۔.`,
  vip_faq_4: `ہر درجے کی جمع رقم کی ضروریات پوری کرنے پر اپ گریڈ خود بخود ہو جاتے ہیں، جس سے آپ فوراً وی آئی پی فوائد سے لطف اندوز ہو سکتے ہیں۔`,
  vip_faq_5: `مجھے اپ گریڈ کیسے کیا جائے گا؟?`,
  vip_faq_6: `مقررہ وقت کے اندر جمع کرنے کی ضروریات پوری کریں۔.`,
  vip_faq_7: `اہلیت کے مطابق وی آئی پی درجے پر خودکار اپ گریڈ۔`,
  vip_faq_8: `وی آئی پی درجے کو چھوڑا نہیں جا سکتا؛ درجے ایک وقت میں ایک ہی بڑھائے جاتے ہیں۔.`,
  vip_faq_9: `مخصوص جمع رقم کی ضروریات کے لیے وی آئی پی درجوں کے چارٹ کا حوالہ دیں۔.`,
  vip_faq_10: `مجھے اپ گریڈ بونس کیسے ملے گا؟`,
  vip_faq_11: `اپ گریڈ کرنے پر بونس فوری طور پر دیئے جاتے ہیں۔ `,
  vip_faq_12: `ہر درجے کے اپ گریڈ بونس کا ایک بار دعوی کیا جا سکتا ہے۔.`,
  vip_faq_13: `30 دنوں کے اندر ہر ڈپازٹ کی ضرورت کو پورا کرکے متعدد سطح کے اپ گریڈ ممکن ہیں۔.`,
  vip_faq_14: `ڈپازٹ کی رقم کا تعین کیسے کیا جاتا ہے؟`,
  vip_faq_15: `جمع شدہ ذخائر کی بنیاد پر.`,
  vip_faq_16: `اپ گریڈ کے بعد اگلے درجے کی جمع رقم کی شرط پچھلے اپ گریڈ کے 30 دنوں کے اندر پوری کرنا ضروری ہے۔.`,
  vip_faq_17: `ٹائم لائنز ہر ممبر کے لیے منفرد ہوتی ہیں۔.`,
  vip_faq_18: `میرا VIP لیول کیوں گھٹا ہوا ہے؟`,
  vip_faq_19: `برقرار رکھنے کی ضرورت کو پورا کرنے میں ناکامی کا نتیجہ تنزلی کی صورت میں نکلتا ہے۔.`,
  vip_faq_20: `اپنی VIP سطح اور فوائد کو برقرار رکھنے کے لیے، ماہانہ برقراری کی رقم حاصل کریں۔.`,
  vip_faq_21: `مثال: VIP سلور کے طور پر رہنے کے لیے، ৳62,500 کی ماہانہ جمع جمع کو برقرار رکھیں`,
  vip_tnc: `وی آئی پی ممبرشپ کی شرائط و ضوابط`,
  vip_tnc_1: `علی ون 789 کو یہ حق حاصل ہے کہ وہ وقتاً فوقتاً کسی بھی وقت بغیر پیشگی اطلاع کے، ریڈیمشن یا اس کے کسی بھی حصے، یا قابل اطلاق شرائط و ضوابط کے کسی بھی حصے میں تبدیلی، منسوخی، ختم یا معطلی کر سکے۔.`,
  vip_tnc_2: `وی آئی پی پروگرام میں حصہ لینے والے اراکین کو مندرجہ بالا قواعد و شرائط اور علی ون 789 کی جانب سے نافذ کیے گئے ویب سائٹ کے تمام متعلقہ قواعد و شرائط کو قبول کرنا اور ان کی پابندی کرنا ضروری ہے۔.`,
  vip_tnc_3: `وی آئی پی ممبرشپ کی شرائط و ضوابط لاگو ہوں گے۔.`,
  vip_benefits: `وی آئی پی ضروریات اور فوائد`,
  vip_upgrade: `وی آئی پی اپ گریڈ`,
  monthly_deposit_requirement: `ماہانہ جمع کی شرط`,
  vip: `وی آئی پی فوائد`,
  upgrade_bonus: `اپ گریڈ بونس`,
  birthday_bns: `سالگرہ کا بونس`,
  merch_and_gifts: `وی آئی پی سامان اور خصوصی تحائف`,
  vip_cs: `ایکسپریس وی آئی پی کسٹمر سپورٹ`,
  vip_priority: `جمع اور نکالنے کی ترجیح`,
  vip_events: `وی آئی پی تقریبات اور تجربات`,
  vip_exclusive_access: `نئی خصوصیات تک خصوصی رسائی`,
  dedicated_manager: `مخصوص وی آئی پی مینیجر`,
  invited_only: `صرف مدعو افراد کے لیے`,
  become_vip: `علی ون 789 کا وی آئی پی بنیں`,
  become_vip_1: `خصوصی آفرز، شاندار تحائف، فراخدلانہ بونسز، اور فطری طور پر اعلیٰ ترین ترجیحی خدمات کے لیے ہمارا وی آئی پی ممبر بنیں۔.`,
  become_vip_2: `اپنی حیثیت کو بلند کریں اور ہمارے ساتھ بے مثال خدمات کا تجربہ کریں۔!`,
  become_vip_3: `علی ون 789 وی آئی پی ممبرشپ میں شامل ہونے کا طریقہ کیا ہے؟`,
  become_vip_4: `بغیر کسی جھنجھٹ کے، بغیر انتظار کے — فوری اپ گریڈ!`,
  become_vip_5: `خودکار اپ گریڈ: وی آئی پی بننے کے لیے جمع رقم کی شرط پوری کریں۔`,
  become_vip_6: `*مزید تفصیلات کے لیے نیچے دیے گئے جدول کو دیکھیں۔.`,
  become_vip_7: `فوری طور پر وی آئی پی فوائد کا لطف اٹھائیں!`,
  vip_retention_requirement: `وی آئی پی برقرار رکھنے کی شرط`,
  monthly_accumulated_deposit: `ماہانہ مجموعی جمع رقم`,
  membership_renewal: `رکنیت کی تجدید`,
  betting_pass: `بیٹنگ پاس`,
  claim_rewards: `انعامات کا دعوی کریں۔`,
  free: `مفت`,
  betting_pass_progress: `آپ کے بیٹنگ پاس کی پیشرفت`,
  deposit_to_level_up: `اپنے بیٹنگ پاس کو برابر کرنے کے لیے ابھی جمع کریں اور اگلے درجے کے انعام کا دعویٰ کریں!`,
  deposit_now: `ابھی جمع کروائیں۔`,
  login_to_claim_betting_pass: `اپنے بیٹنگ پاس انعامات کا دعوی کرنے کے لیے لاگ ان کریں یا ابھی رجسٹر ہوں اور خصوصی بیٹنگ پاس انعامات کو غیر مقفل کرنا شروع کریں۔`,
  betting_pass_title: `علی ون 789 شرط بازی پاس`,
  betting_pass_subtitle: `ہر درجے پر مفت نقدی اور خصوصی انعامات حاصل کریں۔`,
  betting_pass_desc: `علی ون 789 بیٹنگ پاس کے ساتھ نئی بلندیوں کو چھوئیں اور ایک دلچسپ سفر کا آغاز کریں! آپ کی ہر شرط آپ کو آگے بڑھاتی ہے، اور راستے میں آپ کو خصوصی انعامات اور نقد انعامات بھی ملتے ہیں۔ چاہے آپ تجربہ کار بیٹر ہوں یا نئے کھلاڑی، علی ون 789 بیٹنگ پاس ہر کسی کے لیے کچھ خاص پیش کرتا ہے، اور آپ کی ہر جمع شدہ رقم پر آپ کی محنت کو انعام دیتا ہے!`,
  betting_pass_level: `بیٹنگ پاس کی سطح`,
  continue: 'جاری رکھیں',
  congratulations: 'مبارک ہو',
  spin_the_wheel: 'اسپن دی وہیل',
  // TODO: x_lucky_wheel: '{{x}} خوش قسمت پہیہ'',
  stw_description:
    'جب آپ رجسٹر کریں اور رقم جمع کروائیں یا کسی دوست کو ہمارا حصہ بننے کی دعوت دیں تو سکے جمع کریں اور ہمارا خوش قسمت پہیہ گھمائیں تاکہ اصلی نقد انعامات جیت سکیں!',
  how_to_get_coins: 'سکے کیسے حاصل کریں:',
  stw_how_to_get_coins:
    'جمع کروائیں — روزانہ کم از کم ৳200 جمع کروائیں اور جمع شدہ رقم کا 1٪ سکے حاصل کریں۔ مثال: اگر آپ ৳2000 جمع کرواتے ہیں، تو آپ کو 20 سکے ملیں گے۔.',
  coins_required_per_spin_x: 'ہر گھماؤ کے لیے مطلوبہ سکے - {{x}} سکے',
  stw_tnc_1: '1. اراکین کو روزانہ زیادہ سے زیادہ (10) بار خوش قسمت پہیہ گھمانے کی اجازت ہے۔.',
  stw_tnc_2: '2. اراکین کو بونس کی رقم کا 1 گنا ٹرن اوور مکمل کرنا ہوگا تاکہ رقم کی منتقلی یا نکلوانا ممکن ہو سکے۔.',
  stw_tnc_3: '3. پروموشن دستیابی کے تابع ہے۔.',
  stw_tnc_4:
    '4. کوئی بھی شرط جو کالعدم، ٹائی، منسوخ شدہ ہو، یا ایسی شرط جو مخالف طرف ایک ہی نتیجے کے ساتھ لگائی گئی ہو، یا ایسی شرط جس کی آڈز DEC 1.5، CN 0.5، اور MALAY -0.6 سے کم ہو، اسے جائز ٹرن اوور نہیں سمجھا جائے گا۔ روولیٹی پر لگائی گئی شرطوں میں سے صرف آپ کی کل شرطوں کا 1/4 حصہ ٹرن اوور کے طور پر شمار کیا جائے گا۔.',
  stw_tnc_5:
    '5. حصہ لینے والے اراکین کو مندرجہ بالا تمام شرائط اور علی ون 789 کی ویب سائٹ پر درج تمام متعلقہ قواعد و ضوابط کو قبول کرنا اور ان کی پابندی کرنا ضروری ہے۔.',
  stw_tnc_6:
    '6. علی ون 789 کو یہ حق حاصل ہے کہ وہ کسی بھی وقت بغیر پیشگی اطلاع کے پروموشن میں ترمیم، منسوخی، معطلی یا ختم کر سکے اور/یا پروموشن کی شرائط تبدیل کر سکے۔.',
  general_tnc_apply: 'علی ون 789 کے عمومی شرائط و ضوابط لاگو ہوں گے۔.',
  spin: 'گھمائیں',
  apply_voucher: 'واؤچر لگائیں۔',
  enter_voucher: 'واؤچر درج کریں۔',
  x_claimed: '{{x}} نے دعوی کیا۔',
  bonus_unlocked: 'بونس غیر مقفل',
  voucher_code: 'واؤچر کوڈ',
  must_start_with: `فون نمبر کم از کم 11 ہندسوں کا ہونا چاہیے اور اس سے شروع ہونا چاہیے (درست نیٹ ورک یعنی 0300-0309، 0320-0329، 0340-0349، 0310-0319، 0330-0339، 0355)`,
  you_won_x: 'آپ نے {{x}} جیت لیا',
  coins: 'سکے',
  same_phone_no_same_wallet: 'ایک ہی فون نمبر - ایک ہی بینک والیٹ نمبر',
  logout_confirmation: 'لاگ آؤٹ کی تصدیق',
  are_you_sure_to_logout: 'کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟',
  yes: `جی ہاں`,
  adjustment: `ایڈجسٹمنٹ`,
  min_deposit_x: 'کم از کم جمع کروائیں {{x}}',
  follow_us: `ہمیں فالو کریں۔`,
  certification_n_security: `سرٹیفیکیشن اور سیکورٹی بذریعہ:`,
  gaming_license_desc: `Aliwin789 MockingBird Technologies Pte کا ایک رجسٹرڈ ٹریڈ مارک برانڈ ہے۔ لمیٹڈ جو ریگولیٹ اور
                    حکومت انجوان کے ذریعہ لائسنس یافتہ اور لائسنس نمبر ALSI-202410012-FI1 کے تحت کام کرتا ہے`,
  click_to_download: 'جانے کے لیے تیار ہیں؟ Aliwin789 ایپ ڈاؤن لوڈ کرنے اور استعمال کرنے کے لیے نیچے کلک کریں۔',
  enter_x: `{{x}} درج کریں`,
  register_now: `ابھی رجسٹر کریں!`,
  login_now: `ابھی لاگ ان کریں!`,
  code: `کوڈ`,
  fullname_must_be_same: `یقینی بنائیں کہ آپ کا پورا نام آپ کے بینک اکاؤنٹ پر موجود نام سے ملتا ہے، ورنہ کمپنی آپ کی درخواست مسترد کر سکتی ہے۔.`,
  social_media: `سوشل میڈیا`,
  livechat: `لائیو چیٹ`,
  live_transactions: 'لائیو لین دین',
  popular_games: 'مشہور گیمز',
  change_language: `زبان تبدیل کریں۔`,
  deposit_x_to_unlock_next_level: `اگلی سطح کو غیر مقفل کرنے کے لیے {{x}} جمع کریں!`,
  invite_friends_get_reward: 'اپنے دوستوں کو بورڈ پر لائیں اور مزید انعامات حاصل کریں۔',
  invite_your_friends_to_join:
    'اپنے دوستوں کو ہمارے ریفرل پروگرام میں شامل کریں! بس اپنا منفرد لنک یا کوڈ شیئر کریں اور جب وہ سائن اپ کریں اور پلیٹ فارم استعمال کرنا شروع کریں تو انعامات حاصل کریں۔',
  share_via_social_media: 'سوشل میڈیا کے ذریعے شیئر کریں۔',
  total_referral_tier: 'کل ریفرل ٹائر',
  available: 'دستیاب ہے۔',
  my_profile: `میرا پروفائل`,
  general: `جنرل`,
  contact_details: `رابطہ کی تفصیلات`,
  verified_by_play_protect: `Play Protect کے ذریعے تصدیق شدہ`,
  reviews: `26K جائزے`,
  reviews_value: `4M+`,
  rated_for: `18+ کے لیے درجہ بندی کی گئی۔`,
  install: `انسٹال کریں۔`,
  add_to_wishlist: `خواہش کی فہرست میں شامل کریں۔`,
  about_this_app: `اس ایپ کے بارے میں`,
  app_description_1: `Aliwin789 میں خوش آمدید، پاکستان کے سب سے بڑے آن لائن کیسینو پلیٹ فارم، جہاں پر جوش اور جیت ہے۔
              مواقع کبھی نہیں رکتے! چاہے آپ کلاسک کیسینو گیمز کے پرستار ہوں یا جدید، ہائی اسٹیک بیٹنگ کے، ہم
              سب کے لئے کچھ پیش کرتے ہیں. ہمارے وسیع رینج کے گیمز کے سنسنی کا تجربہ کریں، بشمول سلاٹس،
              بلیک جیک، رولیٹی، پوکر، اور بہت کچھ—سب کچھ آپ کے موبائل ڈیوائس کے آرام سے۔`,
  app_description_2: `Aliwin789 میں، ہم آپ کی حفاظت اور گیمنگ کے تجربے کو ترجیح دیتے ہیں۔ ہمارا پلیٹ فارم مکمل طور پر لائسنس یافتہ اور محفوظ ہے،
              ہر وقت منصفانہ کھیل اور ذمہ دار گیمنگ کو یقینی بنانا۔ ہم آپ کی حفاظت کے لیے جدید ٹیکنالوجی استعمال کرتے ہیں۔
              ذاتی معلومات اور تیز ڈپازٹ، فوری واپسی، اور کے ساتھ بغیر کسی رکاوٹ کے گیمنگ کا تجربہ فراہم کریں۔
              24/7 کسٹمر سپورٹ۔`,
  why_choose_brand: `Aliwin789 کیوں منتخب کریں؟`,
  reason_1: `سرفہرست گیم فراہم کنندگان سے گیمز کا ایک وسیع انتخاب`,
  reason_2: `آسان نیویگیشن کے ساتھ صارف دوست انٹرفیس`,
  reason_3: `خصوصی بونس اور پروموشنز صرف آپ کے لیے موزوں ہیں۔`,
  reason_4: `تیز اور محفوظ لین دین کے لیے محفوظ ادائیگی کے اختیارات`,
  reason_5: `آپ کی ترجیح کے مطابق اردو اور انگریزی میں دستیاب ہے۔`,
  app_description_3: `آج ہی ہزاروں مطمئن کھلاڑیوں کے ساتھ شامل ہوں اور پاکستان کے سب سے قابل اعتماد آن لائن کیسینو کے تجربے میں حصہ لیں! چاہے آپ یہاں کھیل کے سنسنی کے لیے موجود ہوں یا بڑا جیتنے کا موقع، Aliwin789 آپ کے لیے نہ ختم ہونے والی تفریح کا گیٹ وے ہے۔`,
  app_download: `ایپ ڈاؤن لوڈ`,
  download_message: `آج ہی ہماری ایپ ڈاؤن لوڈ کریں!`,
  insufficient_coins: 'سکے کم ہیں',
  done: 'ہو گیا',
  vip_levels: `وی آئی پی لیولز`,
  monthly_bonus: `ماہانہ بونس`,
  weekly_bonus: `ہفتہ وار بونس`,
  vip_birthday_bonus: `سالگرہ کا بونس`,
  id_number: 'شناختی نمبر',
  input_otp: 'ان پٹ OTP',
  send_again_in_x: '{{x}} میں دوبارہ بھیجیں',
  day_no: 'دن',
  earn_extra_x_today: 'آج ہی اضافی {{x}} کمائیں۔',
  today: 'آج',
  rtp: "RTP"
  
};

export default ur;
